import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DatabaseService } from 'src/app/core/services/base/database.service';
import { environment } from 'src/environments/environment';

export interface SignedContract {
  id: string;
  url: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class OaSignatureService extends DatabaseService<SignedContract> {
  constructor(private http: HttpClient) {
    super('cp_signed_contract');
  }

  async getAllGroupedByCase(
    claimId: string
  ): Promise<SignedContract | undefined> {
    const query = this.supabase
      .from(this.table)
      .select()
      .eq('status', 'SIGNED')
      .eq('claim_id', claimId);

    const { data, error } = await query;

    if (error) throw new Error(error.message);

    return data?.[0];
  }

  async retract(id: string) {
    const token = (await this.supabase.auth.getSession()).data.session
      ?.access_token;

    const ret = (await firstValueFrom(
      this.http.put(
        environment.lambdaUrl + '/retract_signature',
        { signed_contract_id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    )) as any;

    return ret;
  }
}
